import { render, staticRenderFns } from "./profilesDialog.vue?vue&type=template&id=77666e2b&scoped=true"
import script from "./profilesDialog.vue?vue&type=script&lang=js"
export * from "./profilesDialog.vue?vue&type=script&lang=js"
import style0 from "./profilesDialog.vue?vue&type=style&index=0&id=77666e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77666e2b",
  null
  
)

export default component.exports